import { useEffect, useState } from "react";
import { animate, motion, useMotionValue, useTransform } from "framer-motion";
import { Users } from "lucide-react";
import { api } from "@/auth/AuthContext";

export function MemberCounter() {
  const [count, setCount] = useState(null);
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.round(v).toLocaleString("en-IN"));
  useEffect(() => { api.get("/members/count").then(({ data }) => setCount(data.count)).catch(() => setCount(0)); }, []);
  useEffect(() => { if (count !== null) { const c = animate(mv, count, { duration: 1.6, ease: [0.22, 1, 0.36, 1], delay: 0.3 }); return c.stop; } }, [count, mv]);
  if (count === null) return null;
  if (count < 100) return <motion.div className="member-counter" data-testid="member-counter" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.35, duration: 0.8 }}>
    <Users size={15} /><span data-testid="member-counter-early">Be one of our first learners</span>
  </motion.div>;
  return <motion.div className="member-counter" data-testid="member-counter" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.35, duration: 0.8 }}>
    <Users size={15} /><b><motion.span data-testid="member-counter-value">{rounded}</motion.span></b>
    <span>learners have joined the community</span>
  </motion.div>;
}
